import React from 'react'
import "./PatientDetailsPrintHeader.scss"
import { MocUserRole } from 'core/services/models/Enums'
import moment from 'moment'
import { calculateAge } from 'core/utils/date'

export default function PatientDetailsPrintHeader({
  patientData,
  origin,
  smartSummaryData,
  appointmentDate
}: any) {

  const getReferredByValue = () => {
    let result = ""
    if (patientData?.patientInfo?.referredBy) {
      if (patientData?.patientInfo?.referredBy?.referredBy === "Others") {
        if (patientData?.patientInfo?.referredBy?.refferedByOthers) {
          result = patientData?.patientInfo?.referredBy?.refferedByOthers
        }
      } else if (patientData?.patientInfo?.referredBy?.referredBy === "Doctor") {
        if (patientData?.patientInfo?.referredBy?.doctorName) {
          result = patientData?.patientInfo?.referredBy?.doctorName
        }
      } else {
        if (patientData?.patientInfo?.referredBy?.referredBy) {
          result = patientData?.patientInfo?.referredBy?.referredBy
        }
      }
    }
    return result
  }

  const getDiagnosisString = () => {
    if (smartSummaryData && Object.keys(smartSummaryData)?.length > 0) {
      const diagnosisStr: any = smartSummaryData?.diagnosis?.map((item: any) => {
        return <>
          <span>{item?.diagnosis}&nbsp;</span>
          <span>{item?.diagnosis ? (item?.cancerType) : item?.cancerType}</span>
        </>
      })
      return diagnosisStr
    } else {
      return ""
    }
  }

  return (
    <div className="print-patient-details-container mb-3">
      <div className="print-patient-details-inner-container">
        <div>
          <span className="header-text">Name:</span>
          <span className="value-text">{patientData?.patientInfo?.isVIP ? patientData?.patientInfo?.mocId : patientData?.patientInfo?.name}</span>
        </div>
        <div>
          <span className="header-text">Patient ID:</span>
          <span className="value-text">{patientData?.patientInfo?.mocId}</span>
        </div>
        <div>
          <span className="header-text">Age:</span>
          <span className="value-text">{calculateAge(patientData?.patientInfo?.dob)}</span>
        </div>
        <div>
          <span className="header-text">Gender:</span>
          <span className="value-text">{patientData?.patientInfo?.gender}</span>
        </div>
        {
          origin === MocUserRole?.NUTRITIONIST ? (
            <>
              <div>
                <span className="header-text">Weight:</span>
                <span className="value-text">{patientData?.vitalsData?.weight}</span>
              </div>
              <div>
                <span className="header-text">Height:</span>
                <span className="value-text">{patientData?.vitalsData?.height}</span>
              </div>
              <div>
                <span className="header-text">BMI:</span>
                <span className="value-text">{patientData?.vitalsData?.bmi}</span>
              </div>
            </>
          ) : (
            <>
              <div>
                <span className="header-text">Phone No:</span>
                <span className="value-text">{patientData?.patientInfo?.phoneNumber}</span>
              </div>
              <div>
                <span className="header-text">Primary Consultant:</span>
                <span className="value-text">{patientData?.patientInfo?.primaryConsultantName}</span>
              </div>
              {
                patientData?.patientInfo?.referredBy?.referredBy ? (
                  <div>
                    <span className="header-text">Referred By:</span>
                    <span className="value-text">{getReferredByValue()}</span>
                  </div>
                ) : null
              }
            </>
          )
        }
        {
          smartSummaryData?.diagnosis?.length > 0 && (
            <div className='print-only'>
              <span className="header-text">Diagnosis:</span>
              <span className="value-text">
                {
                  getDiagnosisString()
                }
              </span>
            </div>
          )
        }
        <div className='print-only'>
          <span className="header-text">Date of Appointment:</span>
          <span className="value-text">{appointmentDate ? moment(appointmentDate).format(
            "DD-MM-YYYY"
          ) : moment().format(
            "DD-MM-YYYY"
          )}</span>
        </div>
      </div>
    </div>
  )
}
